import type { SuccessionRiskLevel } from '../models/SuccessionPlanning';

/**
 * Persistent succession views use the product's subtle semantic surface tones.
 * Saturated semantic colors remain reserved for urgent actions and compact
 * indicators rather than full card backgrounds.
 */
export const SUCCESSION_RISK_COLORS: Record<SuccessionRiskLevel, string> = {
  critical: '#FBE6E6', // --color-danger-bg
  high: '#FFF0EE', // --color-coral-100
  medium: '#FDF3D8', // --color-warning-bg
  low: '#E3F7EE', // --color-success-bg
};

const LEGACY_SUCCESSION_RISK_COLORS: Record<SuccessionRiskLevel, string> = {
  critical: '#dc2626',
  high: '#f97316',
  medium: '#eab308',
  low: '#16a34a',
};

const isSuccessionRiskLevel = (value: string): value is SuccessionRiskLevel =>
  value === 'critical' || value === 'high' || value === 'medium' || value === 'low';

/**
 * Migrates only the former built-in colors. User-authored palette overrides
 * remain authoritative.
 */
export function resolveSuccessionRiskDisplayColor(
  riskValue: string,
  configuredColor?: string,
): string | undefined {
  if (!isSuccessionRiskLevel(riskValue)) return configuredColor;
  if (!configuredColor) return SUCCESSION_RISK_COLORS[riskValue];

  return configuredColor.toLowerCase() === LEGACY_SUCCESSION_RISK_COLORS[riskValue]
    ? SUCCESSION_RISK_COLORS[riskValue]
    : configuredColor;
}
